module.exports = __webpack_public_path__ + "static/img/title.0a3b056.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/title.png
// module id = htzI
// module chunks = 7